import { apiCall } from '../../utils';
import { authApiCall } from '../auth/saga';

export const getBusinesses = () =>
  authApiCall({
    url: '/affiliate-coupons/awin-programmes/',
    method: 'get',
  });

export const getProducts = () =>
  authApiCall({
    url: '/affiliate-coupons/awin-products/',
    method: 'get',
  });

export const getPromotions = (advertiser_id = null) =>
  authApiCall({
    url: '/affiliate-coupons/awin-promotions/',
    method: 'get',
    params: advertiser_id ? { advertiser_id } : {},
  });